import { render, staticRenderFns } from "./import-list.vue?vue&type=template&id=c460a9ea&scoped=true&"
import script from "./import-list.vue?vue&type=script&lang=js&"
export * from "./import-list.vue?vue&type=script&lang=js&"
import style0 from "./import-list.vue?vue&type=style&index=0&id=c460a9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c460a9ea",
  null
  
)

export default component.exports